module.exports = __webpack_public_path__ + "static/media/comic_plate_1.c7cfb69e.png";